// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { fetch } from "@insite/client-framework/ServerSideRendering";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type S3UploadFileParameter = {
    orderNumber: string;
    lineNumber: number;
    file: any;
    onError?: (errorMessage: string) => void;
    onSuccess?: (result: any) => void;
};

type HandlerType = ApiHandler<S3UploadFileParameter, ServiceResult<S3UploadFileParameter>>;
const apiUrl = "api/mon/S3Upload/uploadFile";

export const xDispatchBeginLoading: HandlerType = props => {
    props.dispatch({
        isLoading: true,
        type: "xRequestRma/S3UploadFileRequest",
    } as any);
};

export const CallS3UploadFile: HandlerType = async props => {
    await fetch(`${apiUrl}?orderNumber=${props.parameter.orderNumber}`, {
        method: "POST",
        body: props.parameter.file,
    })
        .then(response => {
            if (response.status === 200) {
                return response.json();
            }
            throw new Error("Please Upload a File Up To 5MB.");
        })
        .then(result => {
            props.apiResult = {
                result,
                successful: true,
            };
        })
        .catch(error => {
            props.apiResult = {
                errorMessage: error.message,
                successful: false,
            };
        });
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [xDispatchBeginLoading, CallS3UploadFile, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const xS3UploadFileRequest = createHandlerChainRunner(chain, "S3UploadFileRequest");
export default xS3UploadFileRequest;
